<template>
  <div v-if="loaded">
    <div class="columns margin-logo">
      <div class="column is-10">
        <h1 class="title page-base__title has-text-primary">
          Editando instalação da {{ appDetails.app.name }}
        </h1>
      </div>
      <div class="column is-2">
        <img :src="appDetails.app.imgUrl" v-if="appDetails.app.imgUrl" class="img-client" />
      </div>
    </div>
    <sc-tab/>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
  ScPageBase,
} from '@intelipost-js/secure-components';
import ScTab from './components/sc-tab/ScTab';

const { mapState, mapActions } = createNamespacedHelpers('integrations/integrationsAppEdit');

export default {
  name: 'integrations-app-v2',
  data() {
    return {
      loaded: false,
    };
  },
  methods: {
    ...mapActions(['getAppAndInstalation']),
  },
  computed: {
    ...mapState([
      'appDetails',
      'loading',
    ]),
  },
  async created() {
    const app_id = this.$route.params.id;
    await this.getAppAndInstalation(app_id);
    this.loaded = true;
  },
  components: {
    ScPageBase,
    ScTab,
  },
};
</script>

<style lang='scss'>
@import "~@intelipost-js/secure-ui/src/scss/variables";
  .img-client {
    height: 80px;
  }
  .margin-logo{
    margin-top: 10px;
  }
</style>




// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-edit/IntegrationsAppEdit.vue